<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{period}}</h4>
                <p style="font-size: 12px">{{current_datetime}}h</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-clock-o fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{pot_contracted}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.contracted_power}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-flash fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{api_general}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.general_power}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-plug fa-4x card-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{api_generator}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.generator_power}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-plug fa-4x card-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.shunting_status}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-shuffle font-2xl"></i>
                <span class="px-2">{{web_texts.partials.selector_status}}</span>
              </div>
              <button v-if="selector_status==='AUTO'" class="btn col-md-5 btn-success btn-lg btn-block" disabled>AUTO</button>
              <button v-else-if="selector_status==='MAN'" type="button" class="btn col-md-5 btn-success btn-lg btn-block" disabled>MAN</button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
            <br>
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-share font-2xl"></i>
                <span class="px-2">{{web_texts.partials.contactor_status}}</span>
              </div>
              <button v-if="contactor_status==='XARXA'" class="btn col-md-5 btn-success btn-lg btn-block" disabled>{{web_texts.partials.net_supply}}</button>
              <button v-else-if="contactor_status==='GRUP'" type="button" class="btn col-md-5 btn-success btn-lg btn-block" disabled>{{web_texts.partials.generator}}</button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
            <br>
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-flag font-2xl"></i>
                <span class="px-2">{{web_texts.partials.generator_status}}</span>
              </div>
              <button v-if="generator_status==='OFF'" class="btn col-md-5 btn-danger btn-lg btn-block" disabled>OFF</button>
              <button v-else-if="generator_status==='ON'" type="button" class="btn col-md-5 btn-success btn-lg btn-block" disabled>ON</button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
            <br>
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-control-end font-2xl"></i>
                <span class="px-2">{{web_texts.partials.emergency_stop}}</span>
              </div>
              <button v-if="generator_status==='OFF'" class="btn col-md-5 btn-default btn-lg btn-block" disabled>{{web_texts.partials.deactivated}}</button>
              <button v-else-if="generator_status==='ON'" type="button" class="btn col-md-5 btn-danger btn-lg btn-block" @click="changeGeneratorStatus()">OFF</button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>

          </div>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.shuntings}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">
            <vue-good-table :columns="columns" :rows="list_events" :paginate="true" :perPage="4"
                            :defaultSortBy="{field: 'date', type: 'desc'}">
              <template slot="table-row" scope="props">
                <td :class="props.row.value">{{ props.row.date }}</td>
                <td :class="props.row.value">{{ props.row.shunter }}</td>
                <td :class="props.row.value">{{ props.row.value }}</td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.compare_powers}}</span>
          </div>
          <div class="card-block">
            <div id="pot-act-gen-gru-comparador" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../../../translates/cat/Shuntting';
  import trans_es from '../../../translates/es/Shuntting';
  import constants from '../../../constants';
  import middleware from '../../../utilities/middlewares';
  import dateRanges from '../../../utilities/dates_intervals';
  import dataTransforms from '../../../utilities/data_transformers';

  export default {
    name: 'GeneratorShunting',
    props: ['devices'],
    data() {
      return {
        web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
        general: '',
        period: 'S/D',
        masters:'',
        current_datetime: 'S/D',
        pot_contracted: 'S/D',
        class_card_color: 'card-success',
        api_general: 'S/D',
        api_generator: 'S/D',
        generator_status: 'S/D',
        contactor_status: 'S/D',
        selector_status: 'S/D',
        list_events: [],
        columns: [
          {
            label: 'Data',
            field: 'date',
            type: 'date',
            inputFormat: 'DD/MM/YYYY HH:mm:ss',
            width: '180px',
            html: true
          },
          {
            label: 'Dispositiu',
            field: 'shunter',
            html: true
          },
          {
            label: 'Estat',
            field: 'value',
            html: true
          }
        ]
      }
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["shunt","generator_shunt"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      var out = this;
      this.system = JSON.parse(window.localStorage.getItem('system'));

      console.log("Created Generator Shunt");
      this.current_datetime = dateRanges.getCurrentDateTime();
      this.getHeadCardsInfo();
      this.getRealTimeValues(this.getGeneralDevice());
      this.getMasterEventsGeneratorRT(JSON.parse(window.localStorage.getItem('masters')));

      var generator_shunt_interval = setInterval(function () {
        console.log("Interval Generator Shunt");
        var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
        if (contr_rt[1] !== "generator_shunt") {
          console.log("Clear Generator Shunt");
          clearInterval(generator_shunt_interval);
        } else {
          this.current_datetime = dateRanges.getCurrentDateTime();
          out.getHeadCardsInfo();
          out.getRealTimeValues();
          out.getMasterEventsGeneratorRT(JSON.parse(window.localStorage.getItem('masters')));
        }
      }, 5000);
    },
    mounted(){
      this.getEventsGenerator();
      this.getMonthlyActivePowerComparator();
    },
    methods: {
      // Llegir potencia i periodes per a les cards (esta dins del interval)
      getHeadCardsInfo() {
        axios.post(constants.ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
          client_device: 'd',
          system_id: this.system.id
        }).then((response) => {
          this.period = response.data.period;
          this.pot_contracted = parseInt(response.data.pot_contracted);
        }, (response) => {
          console.log(response);
        });
      },
      // Agafar el general i el generador dels devices
      getGeneralDevice() {
        var devices = this.devices;
        for (var i = 0; i < devices.length; i++) {
          if (devices[i].name.indexOf("General") > 0) {
            this.general = devices[i];
          } else if (devices[i].name.indexOf("Grup") > 0) {
            this.generator = devices[i];
          }
        }
      },
      // Llegir valors en temps real (esta dins del interval)
      getRealTimeValues() {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.general.id, "API"], [this.generator.id, "API"]])
        }).then((response) => {
          this.api_general = Math.round(response.data[0].value * 10) / 10;
          this.api_generator = Math.round(response.data[1].value * 10) / 10;
        }, (response) => {
          console.log(response.data);
        });
      },
      // Llegir un event determinat
      getEventsGenerator() {
        axios.post(constants.ROOT_URL + '/api/v1/event', {
          system_id: this.system.id,
          event: "R$EVE_E_GrupOFF",
          client_device: 'd',
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          function reverseEve(st) {
            if (st === "ON") {
              return "OFF"
            } else {
              return "ON"
            }
          }

          var response_return = [];
          if (response.data.hasOwnProperty("record")) {
            for (var i = 0; i < response.data.record.length; i++) {
              response_return.push({
                date: moment(response.data.record[i].date, "DDMMYYYYhhmmss").add(1, 'h').format('DD/MM/YYYY HH:mm:ss'),
                shunter: "Grup",
                value: reverseEve(response.data.record[i].value)
              });
            }
          }
          this.list_events = response_return;
        }, (response) => {
          console.log(response.data)
        })
      },
      // llegir els events (esta dins del interval)
      getMasterEventsGeneratorRT(masters){
        var master_id = masters[0].id;
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[master_id, "R$EVE_E_GrupOFF.ST", "R$EVE_I_Selector.ST", "R$EVE_M_ContactorCamares.ST", "R$EVE_M_ContactorXarxa.ST"]])
        }).then((response) => {
          console.log(response.data);
          if(parseInt(response.data[0].value)===1){
            this.generator_status = "OFF"
          } else if(parseInt(response.data[0].value)===0){
            this.generator_status = "ON"
          }else{
            this.generator_status = "S/D"
          }

          if(parseInt(response.data[1].value)===1){
            this.selector_status = "MAN"
          } else if(parseInt(response.data[1].value)===0){
            this.selector_status = "AUTO"
          }else{
            this.selector_status = "S/D"
          }

          if(parseInt(response.data[2].value)===1){
            this.contactor_status = "GRUP"
          } else if(parseInt(response.data[3].value)===1){
            this.contactor_status = "XARXA"
          }else{
            this.contactor_status = "S/D"
          }
        }, (response) => {
          console.log(response.data);
        });
      },
      // Llegir dades per al graf
      getMonthlyActivePowerComparator(){
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.generator.id, "API"],[this.general.id, "API"]]),
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          this.printMonthlyActivePowerComparator(dataTransforms.lineDataTransformCanvasJS(response.data, "line", ["Pot. Grup", "Pot. General"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      // print graf
      printMonthlyActivePowerComparator(data){
        try {
          //Better to construct options first and then pass it as a parameter
          var options = {
            zoomEnabled: true,
            animationEnabled: true,
            axisX: {
              valueFormatString: "DD/MM/YYYY HH:mm"
            },
            axisY: {
              suffix: "kW"
            },
            data: data  // random data
          };

          $("#pot-act-gen-gru-comparador").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      },
      //Pegunt si es vol fer la maniobra
      changeGeneratorStatus(){
        swal({
          title: 'Maniobra Grup!',
          text: "Està segur que vol posar el grup a OFF?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'SI',
          cancelButtonText: 'NO'
        }).then((result) => {
          if (result.value) {
            this.forceVariableFunction(this.masters, "DO5", 1)
          }
        })
      },
      // Cambiar variable a un dispositiu
      forceVariableFunction(device, var_to_change, new_value) {
        var master_name = device[0].name;
        axios.post(constants.ROOT_URL + '/api/v1/shunting_action', {
          system_id: this.system.id,
          device: master_name,
          var_to_change: var_to_change,
          client_device: 'd',
          new_value: new_value
        }).then((response) => {
          console.log(response.data);
          swal(
            'Completat!',
            'Acció completada correctament.',
            'success'
          )
        }, (response) => {
          console.log(response.data);
          swal(
            'ERROR',
            'Acció no completada',
            'error'
          )
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// GeneratorShunting.vue?ee173b56